import { showToast } from 'shared/toast/showToast'
import ReminderCreatedToast from './ReminderCreatedToast'

export const showReminderCreatedToast = () =>
  showToast({
    render: (isOpen) => <ReminderCreatedToast isOpen={isOpen} />,
    timeout: 5000,
  })
